import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { FormSectionBone } from '../../organisms/FormSectionBone/FormSectionBone';

interface FormSectionSkeletonProps {
    /** Nom de la section */
    name?: string;
    /** Nombre total de sections */
    sectionsCount?: number;
    /** Mode fragment uniquement */
    fragmentOnlyRender?: boolean;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const FormSectionSkeleton: React.FunctionComponent<FormSectionSkeletonProps> = function ({
    name = 'section',
    sectionsCount = 1,
    fragmentOnlyRender = true,
    sx = {},
}) {
    const calculatedHeight = fragmentOnlyRender ? `${100 / sectionsCount}vh` : 'auto';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: calculatedHeight,
                ...sx,
            }}
        >
            <FormSectionBone
                sectionName={name}
                totalSections={sectionsCount}
                showHeader={!fragmentOnlyRender}
            />
        </Box>
    );
};
